var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#6d38fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "circle-wavy-check-fill",
    transform: "translate(454.236 910.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672",
    "data-name": "Rectangle 1672",
    width: 28,
    height: 28,
    transform: "translate(-0.236 -0.053)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9700",
    "data-name": "Path 9700",
    d: "M39.042,25.532a5.051,5.051,0,0,1-1-1.27,4.844,4.844,0,0,1-.166-1.53,4.264,4.264,0,0,0-.879-3.13,4.264,4.264,0,0,0-3.13-.879,4.844,4.844,0,0,1-1.53-.166,5.052,5.052,0,0,1-1.27-1A4.221,4.221,0,0,0,28.3,16a4.221,4.221,0,0,0-2.765,1.552,5.051,5.051,0,0,1-1.27,1,4.844,4.844,0,0,1-1.53.166,4.264,4.264,0,0,0-3.13.879,4.264,4.264,0,0,0-.879,3.13,4.844,4.844,0,0,1-.166,1.53,5.053,5.053,0,0,1-1,1.27A4.221,4.221,0,0,0,16,28.3a4.221,4.221,0,0,0,1.552,2.765,5.05,5.05,0,0,1,1,1.27,4.844,4.844,0,0,1,.166,1.53,4.264,4.264,0,0,0,.879,3.13,4.264,4.264,0,0,0,3.13.879,4.844,4.844,0,0,1,1.53.166,5.052,5.052,0,0,1,1.27,1A4.221,4.221,0,0,0,28.3,40.594a4.221,4.221,0,0,0,2.765-1.552,5.051,5.051,0,0,1,1.27-1,4.843,4.843,0,0,1,1.53-.166,4.264,4.264,0,0,0,3.13-.879,4.264,4.264,0,0,0,.879-3.13,4.844,4.844,0,0,1,.166-1.53,5.052,5.052,0,0,1,1-1.27A4.221,4.221,0,0,0,40.594,28.3,4.221,4.221,0,0,0,39.042,25.532Zm-5.307.765-6.441,6.148a.878.878,0,0,1-1.213,0L22.86,29.371A.878.878,0,0,1,24.072,28.1l2.614,2.5,5.835-5.57A.878.878,0,0,1,33.734,26.3Z",
    transform: "translate(-14.726 -14.406)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHired);
export default __webpack_public_path__ + "static/media/hired.ffb7a978d80d99294f99041467521c70.svg";
export { ForwardRef as ReactComponent };